import { render } from "./quoteElement.vue?vue&type=template&id=cd68df2e"
import script from "./quoteElement.vue?vue&type=script&lang=js"
export * from "./quoteElement.vue?vue&type=script&lang=js"

import "./quoteElement.vue?vue&type=style&index=0&id=cd68df2e&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__